import { Box, Icon, Typography } from '@ace-clublabs/shared-component-library';
import { IconName } from '@ace-clublabs/shared-component-library/dist/components/Icons';

export interface PillTagProps {
  content: string | React.ReactNode;
  color?: string;
  backgroundColor?: string;
  boxShadow?: string;
  className?: string;
  displayMethod?: 'mobileOnly' | 'desktopOnly';
}

export const PillTag = ({ content, color, backgroundColor, boxShadow, className, displayMethod }: PillTagProps) => {
  return (
    <Box
      className={className}
      sx={{
        borderRadius: '15px',
        boxShadow: boxShadow || 'none',
        background: backgroundColor || 'var(--black-grey-white, #FFF)',
        display:
          displayMethod === 'mobileOnly'
            ? { xs: 'block', lg: 'none' }
            : displayMethod === 'desktopOnly'
              ? { xs: 'none', lg: 'block' }
              : 'block',
      }}
    >
      <Box padding="0.25rem 1rem" sx={{ color: color || '#0156A3' }}>
        {typeof content === 'string' ? (
          <Typography variant="b3Medium" sx={{ color: 'inherit' }}>
            {content}
          </Typography>
        ) : (
          content
        )}
      </Box>
    </Box>
  );
};
